<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0" color="white" fixed flat scroll-off-screen>
        <v-btn icon @click="$router.go(-1)">
          <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile flat class="mt-5 pt-4 text-xs-left">
          <v-card-title class="px-3">
            <span class="tour-name">{{ tourName }}<br>떠나볼까요?</span>
          </v-card-title>
          <v-card-actions class="pa-3">
            <v-btn depressed round color="#f8f9ff" @click.stop="sheet = true" style="height: 46px;">
              <span class="nation-select-text">{{ tourNationName ? tourNationName : '나라를 선택해주세요' }}</span>
              <v-icon size="16px" color="#9497b2">$vuetify.icons.arrowDown</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card flat tile class="text-xs-left" style="position: relative; border-bottom: 1px solid #eaeaea;">
          <v-btn flat class="pseudo-tab-button active ma-0">홈</v-btn>
          <v-btn flat class="pseudo-tab-button ma-0" @click="$router.push({ name: 'TourGuide', params: { idx, tourName } })">가이드</v-btn>
          <v-btn flat class="pseudo-tab-button ma-0" v-if="idx === 2 || idx === 5" @click="$router.push({ name: 'TourPrograms', params: { idx, tourName } })">프로그램</v-btn>
          <v-btn flat class="pseudo-tab-button ma-0" v-if="idx === 5 || idx === 1 || idx === 3" @click="$router.push({ name: 'TourClass', params: { idx, tourName } })">클래스</v-btn>

          <div class="pseudo-tab-indicator"></div>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card tile class="py-2 mt-2 overflow-x-hidden card-shadow">
          <v-card-title primary-title class="pb-0 pt-1 text-xs-left title-style">
            <h1 class="display-4">{{ fromCuration.subjects.title }}</h1>
          </v-card-title>

          <v-card-title class="py-0" v-if="fromCuration.subjects.introduce">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">{{ fromCuration.subjects.introduce }}</span>
            </v-layout>
          </v-card-title>

          <v-card-text class="ma-0 pt-3 pl-0 pr-0 pb-0">

            <div :id="`slide-fromCuration`"
                 class="swiper-container"
                 :class="fromCuration.contents.length === 1 ? '' : 'post-swiper-container'">
              <div class="post-swiper-wrapper swiper-wrapper">
                <div class="post-swiper-slide swiper-slide"
                     :class="fromCuration.contents.length === 1 ? 'px-3' : ''"
                     style="box-sizing: border-box;"
                     :style="{ width: fromCuration.contents.length === 1 ? '100%' : '300px' }"
                     v-for="post of fromCuration.contents" :key="post.idx">
                  <ContentCard :width="fromCuration.contents.length > 1 ? '300px' : ''"
                               :idx="post.idx"
                               :type="post.type"
                               :video_id="post.video_id"
                               :thumbnail="post.thumbnail"
                               :title="post.title"
                               :subtitle="post.subtitle"
                               :subtitle_color="post.subtitle_color" />
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card tile class="py-2 mt-2 overflow-x-hidden card-shadow" v-for="(section, index) of recommendContents" :key="index">
          <v-card-title primary-title class="pb-0 pt-1 text-xs-left title-style">
            <h1 class="display-4">{{ section.subjects.title }}</h1>
          </v-card-title>

          <v-card-title class="py-0" v-if="section.subjects.introduce">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">{{ section.subjects.introduce }}</span>
            </v-layout>
          </v-card-title>

          <v-card-text class="ma-0 pt-3 pl-0 pr-0 pb-0">

            <div :id="`slide-${index}`"
                 class="swiper-container"
                 :class="section.contents.length === 1 ? '' : 'post-swiper-container'">
              <div class="post-swiper-wrapper swiper-wrapper">
                <div class="post-swiper-slide swiper-slide"
                     :class="section.contents.length === 1 ? 'px-3' : ''"
                     style="box-sizing: border-box;"
                     :style="{ width: section.contents.length === 1 ? '100%' : '300px' }"
                     v-for="post of section.contents" :key="post.idx">
                  <ContentCard :width="section.contents.length > 1 ? '300px' : ''"
                               :idx="post.idx"
                               :type="post.type"
                               :video_id="post.video_id"
                               :thumbnail="post.thumbnail"
                               :title="post.title"
                               :subtitle="post.subtitle"
                               :subtitle_color="post.subtitle_color" />
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>

    <!-- 나라 선택시 아래 다이얼로그 -->
    <v-bottom-sheet v-model="sheet">
      <v-card class="bottom-sheet-custom">
        <div class="bottom-sheet-custom-holder">
          <div class="bottom-sheet-custom-gradient-holder"></div>
          <v-list class="pa-0">
            <v-list-tile v-for="nation of tourNations" :key="nation.code"
                         class="nation-list-tile"
                         @click="changeNation(nation.idx, nation.name)">
              <span>{{ nation.name }}</span>
              <v-icon color="#ec2f54" size="16px" v-if="tourNationIdx === nation.idx">$vuetify.icons.confirm</v-icon>
            </v-list-tile>
          </v-list>
        </div>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import ContentCard from "@/components/ContentCard";
  import { mapGetters, mapActions } from 'vuex';
  import { urlToLink } from '@/util/util';

  export default {
    name: 'TourHome',
    components: { ContentCard },
    props: {
      idx: {
        type: Number,
        required: true
      },
    },
    computed: {
      ...mapGetters('home', [ 'curations' ]),
      ...mapGetters('tour', [ 'tourIdx', 'tourName', 'tourNationIdx', 'tourNationName', 'tourNations', 'recommendContents', 'hotStore' ]),
      // ...mapGetters('user', { userIdx: 'idx' }),
      thumbnailSrc () {
        return require('@/assets/img/profile-default.png');
      },
      linkedIntroduce () {
        return urlToLink(this.channel.introduce);
      },
      fromCuration () {
        let target = this.curations.find((el) => {
          return el.subjects.idx === this.idx;
        });
        return {
          subjects: { title: `NEW! ${this.tourName}`, introduce: '따끈따끈한 최신 소식' },
          contents: target.contents
        }
      }
    },
    data () {
      return {
        // loading: true,
        // isScroll: false,
        // activeTab: null,
        sheet: false,
        hotStoriesSwiper: null,
        curationSwipers: [],
      };
    },
    created () {
      if (this.idx !== this.tourIdx) {
        this.setTourNation({ idx: 0, name: '' });
      }
      this.selectHomeAndInitSwiper(this.idx, this.tourNationIdx, this.tourNationName);
      this.selectTourNations(this.idx);
    },
    methods: {
      // ...mapMutations('channel', { mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION' }),
      // ...mapActions('channel', [ 'selectChannel', 'toggleSubscription' ]),
      ...mapActions('tour', [ 'selectTourHome', 'selectTourNations', 'setTourNation' ]),
      selectHomeAndInitSwiper (idx, nationIdx, nationName) {
        this.selectTourHome({
          idx,
          nationIdx: nationIdx === 0 ? undefined : nationIdx,
          nationName: nationName === '' ? undefined : nationName
        }).then(() => {
          this.$nextTick(() => {
            if (!this.hotStoriesSwiper) {
              this.hotStoriesSwiper = new Swiper('.hot-stories-swiper-container', {
                direction: 'horizontal',
                slidesPerView: 2,
                spaceBetween: 10,
              });
            } else if (this.hotStore.length) {
              this.hotStoriesSwiper.update();
            }

            let containers = document.querySelector('.post-swiper-container');
            if (containers) {
              let swiper = new Swiper('.post-swiper-container', {
                direction: 'horizontal',
                slidesPerView: 'auto',
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                // width: 300,
                spaceBetween: 8,
                on: {
                  init() {
                    this.el.classList.remove('post-swiper-container');
                  }
                }
              });
              if (typeof swiper.length !== 'undefined') this.curationSwipers.push(...swiper);
              else this.curationSwipers.push(swiper);
            }
          });
        });
      },
      changeNation (nationIdx, nationName) {
        if (nationIdx === this.tourNationIdx) {
          this.setTourNation({ idx: 0, name: '' });
          this.selectHomeAndInitSwiper(this.idx);
        } else {
          this.setTourNation({ idx: nationIdx, name: nationName });
          this.selectHomeAndInitSwiper(this.idx, nationIdx, nationName);
        }
        this.sheet = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .tour-name {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.36px;
    font-weight: 700;
  }

  .nation-select-text {
    color: #9497b2;
    font-size: 14px;
    letter-spacing: -0.58px;
    margin-right: 8px;
  }

  .pseudo-tab {
    &-button {
      box-sizing: border-box;
      min-width: 0;
      width: 80px;
      height: 48px;

      font-size: 16px;
      font-weight: 700;
      color: #9b9b9b;
      letter-spacing: -0.53px;
      &.active {
        color: #4a4a4a;
      }
    }
    &-indicator {
      position: absolute;
      left: 8px;
      bottom: 0;

      width: 64px;
      height: 3px;
      background-color: rgb(74, 74, 74);
      border-color: rgb(74, 74, 74);
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
    }
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .bottom-sheet-custom {
    height: calc(100vh - 260px);
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    padding-top: 27px;
    &-holder {
      position: relative;
      padding-bottom: 168px;
      height: 100%;
      overflow-y: scroll;
      border-radius: 0 !important;
    }
    &-gradient-holder {
      position: fixed;
      bottom: 0;
      width: 100vw;
      height: 168px;
      z-index: 1;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
    }
  }
  /deep/.nation-list-tile .v-list__tile {
    height: 56px;
    padding: 0 32px;

    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.36px;
    font-weight: 700;

    display: flex;
    justify-content: space-between;
  }
</style>

<style>
  .v-bottom-sheet {
    border-top-right-radius: 30px !important;
    border-top-left-radius: 30px !important;
  }
</style>
